<template>
  <div id="root">
    <div id="app" class="logged-in">
      <div id="app-menu">
        <div id="app-menu-content-wrapper">
          <div id="app-menu-content">
            <div style="padding:5px;display:flex;justify-content: space-between;margin-bottom:15px;cursor: pointer;">
              <span :style="'font-weight: bold;font-size: 15px;color:#a58cff;visibility:hidden'"></span>
              <i @click="gotoMainPage()" class="fa-solid fa-x"
                style="align-self: center ;font-weight: bold;font-size: 20px;color:white"></i>
            </div>
            <img
              :style="isMobile == true ? 'height: 95vw;border-radius: 20px;' : 'height: 50vh;border-radius: 20px;display:flex;margin:auto'"
              :src="require('@/assets/img/50discount.png')" />
            <div style="display:grid;text-align: center;margin-top:15px;">
              <span style="font-size: 22px;color: white;font-weight: bold;">به کاربران حرفه ای روبو ملحق شو!</span>
              <span style="font-size: 17px;color: white;margin-top:5px">همین حالا کاراتو با سرعت 10 برابر بیشتر انجام
                بده</span>
              <span style="font-size: 17px;color: white;margin-top:5px">با 50 درصد تخفیف خفن برای تو که خاص پسندی</span>
            </div>
            <div
              :style="isMobile == true ? 'text-align: center;display: flex;padding:10px' : 'text-align: center;display: flex;padding:10px;justify-content:center'">
              <span
                :style="isMobile == true ? 'font-size: 25px;color: rgb(255, 6, 6);margin-top:5px;' : 'font-size: 25px;color: rgb(255, 6, 6);margin-top:5px;'">مدت
                محدود ⏰:</span>
              <div :style="isMobile == true ? 'margin: auto;display: flex;' : 'margin-right: 20px;display: flex;'"
                id="timer2"></div>
            </div>
            <div
              style="padding: 10px;background-color: #303030;border-radius: 10px;box-shadow: 2px 2px 4px rgba(black, 0.25);">
              <div :style="isMobile == true ? 'display:flex;' : 'display:flex;width:400px;height:130px'">

                <img
                  :style="isMobile == true ? 'border-radius: 10px;width:30vw;height:30vw;margin-top:13px;margin-right:5px;' : 'border-radius: 10px;margin-top:5px;margin-right:5px;'"
                  :src="require('@/assets/img/unlimitedcookie.jpg')" />

                <div style="margin-top:5px;margin-right:15px;width:100%;">

                  <div>
                    <span style="font-size:17px;font-weight:bold;font-family: IRANSansWeb;color:white">معدن
                      کوکی🍪</span>
                  </div>
                  <div style="margin-top: 5px;margin-right:5px">
                    <span style="font-size:14px;font-weight:800;font-family: IRANSansWeb;color:white">کوکی نامحدود
                      ∞</span>
                  </div>
                  <div style="display:grid;margin-top: 10px;">
                    <span
                      style="font-size:17px;font-family: IRANSansWeb;color:#ff0000;text-decoration: line-through;">ماهیانه:
                      598,000 تومان</span>
                    <span style="font-size:17px;font-weight:bold;font-family: IRANSansWeb;color:#a397fa">ماهیانه: 299,000
                      تومان</span>
                  </div>
                </div>

              </div>
              <div v-if="isApplication" @click="showPackage2()"
                style="margin-top:10px;text-align: center;padding:5px;border-radius: 5px;background-color: #E23E57;color:white;font-weight: bold;font-size:15px">
                <i style="padding: 10px;color:white" class="fa-solid fa-shopping-basket"></i>همین حالا خرید کنید!
              </div>
              <div v-else @click="makePayment()"
                style="margin-top:10px;text-align: center;padding:5px;border-radius: 5px;background-color: #E23E57;color:white;font-weight: bold;font-size:15px;cursor: pointer;">
                <i style="padding: 10px;color:white" class="fa-solid fa-shopping-basket"></i>همین حالا خرید کنید!
              </div>

            </div>
          </div>

        </div>
      </div>
      <div v-if="isModalVisible" class="login-box" style="padding:20px;">
        <button style="font-size:20px" @click="closeModal()" id="x">
          <i class="fa-solid fa-times fa-lg" style="color: #ff000d;"></i>
        </button>
        <h2 style="font-weight: bold;font-size:20px">خرید {{ this.plan }}</h2>
        <div v-if="this.isApplication">
          <p style="color: rgb(255, 0, 0);text-decoration: line-through;font-size:17px">مبلغ اشتراک: {{ this.mablagh }}
            تومان</p>
          <p style="color: #7967ff;font-size:20px;font-weight:bold">مبلغ کل: {{ this.kol }} تومان</p>
        </div>
        <form>
          <h5 :style="messageColor">{{ messagePaien }}
          </h5>
          <div @click="buyAndroid()"
            style="display: flex;justify-content: center;margin-top: 10px;text-align: center;margin-left:5px;">
            <div
              style="padding:5px;border-radius: 5px;background-color: #E23E57;width:80vw;color:white;font-weight: bold;font-size:20px">
              پرداخت<i style="padding: 10px;color:white" class="fa-solid fa-money-bills"></i></div>
          </div>
        </form>

      </div>
      <div v-if="isModalUpdate" style="z-index:100000" class="login-box">
        <div style="margin-top: 15px;display: grid;">
          <span style="font-size:20px;font-weight: bold;color:white"><i class="fa-solid fa-download"
              style="font-size:20px;color:#6153cc"></i> بروزرسانی</span>
          <span style="padding:5px;margin-top:5px;font-size:15px;color:white">برای استفاده از روبو ویژن، لطفا برنامه خود
            را بروزرسانی کنید.</span>
          <div
            style="display: flex;justify-content: space-between;margin-top: 10px;margin-bottom: 10px;text-align: center;">
            <div @click="goUpdate()"
              style="padding:10px;border-radius: 5px;background-color: #6153cc;width:90px;color:white;font-weight: bold;font-size:12px">
              بروزرسانی</div>
            <div @click="exit()"
              style="padding:10px;border-radius: 5px;background-color: #6153cc;width:90px;color:white;font-weight: bold;font-size:12px">
              بعدا</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
/* eslint-disable */
import router from '@/router';
import axios from 'axios';
import Lottie from 'vue-lottie';
import * as animationData from '@/assets/img/gZcZ3uuOTR.json';
import markdown from 'markdown-it';
import markdownItLatex from 'markdown-it-texmath'
import katex from 'katex'
var md = new markdown();
md.use(markdownItLatex, {
  engine: katex,
  delimiters: 'brackets',
  katexOptions: { output: "mathml" }
});
import { notify } from "@kyvg/vue3-notification";
export default {
  name: 'App',
  components: {
    'lottie': Lottie
  },
  data() {
    return {
      mablagh: '149,000',
      package: 1,
      package1: 29000,
      package2: 149000,
      package3: 139000,
      discountCode: '',
      messagePaien: '',
      percent: 0,
      lastCode: '',
      kol: '',
      maliat: '',
      intervalId: null,
      isModalVisible: false,
      promotionDate: null,
      messageColor: 'color: red',
      plan: 'جعبه کوکی🍪',
      isApplication: navigator.userAgent.match(/ir.roboo.pwa/i) ? true : false,
      isMobile: navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i) ? true : false,
    };
  },
  methods: {
    gotoMainPage() {
      clearInterval(this.intervalId);
      router.push("/");
    },
    buyAndroid() {
      Android.kharid('plan-2-50');
    },
    closeModal() {
      this.isModalVisible = false;
      document.getElementById('app-menu-content').setAttribute("style", "filter: blur(0px);");
    },
    makePayment() {
      let loadings = this.$loading.show({
        // Optional parameters
        isFullPage: true,
        canCancel: false,
        loader: "bars",
        color: "#3e5ada",
        height: "100",
        width: "90",
      });
      axios
        .post("https://api.roboo.ir/api/Payment/MakePayment?Token=" + localStorage.getItem("token") + "&Package=2&DiscountCode=promotionx50")
        .then(response => {
          if (response.data != "") {
            window.location = response.data;
            loadings.hide();
          }
          else {
            notify({
              title: "خطا",
              text: response.data.message,
              type: "error"
            });
          }
        });

    },
    showPackage2() {
      this.package = 2;
      this.plan = "معدن کوکی🍪";
      this.maliat = "2,205";
      this.kol = "299,000";
      this.mablagh = "598,000";
      this.messagePaien = "";
      this.discountDisable = false;
      this.isModalVisible = true;
      this.percent = 0;
      this.lastCode = "";
      document.getElementById('app-menu-content').setAttribute("style", "filter: blur(5px);");

    },
  },
  mounted() {
    var that = this;
    function updateTimer() {
      var timer = document.getElementById("timer2");
      if (timer == null) {
        clearInterval(that.intervalId);
        return;
      }
      var future = that.promotionDate;
      var now = new Date();
      var diff = future - now;

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor(diff / (1000 * 60 * 60));
      var mins = Math.floor(diff / (1000 * 60));
      var secs = Math.floor(diff / 1000);

      var h = hours - days * 24;
      var m = mins - hours * 60;
      var s = secs - mins * 60;


      timer.innerHTML =
        '<div>' + s + ':</div>' +
        '<div>' + m + ':</div>' +
        '<div>' + h + '</div>';

    }
    if (localStorage.getItem("promotionDate") != null) {
      var promotion = Date.parse(localStorage.getItem("promotionDate"));
      var date = new Date();
      this.promotionDate = promotion;
      updateTimer();
      this.intervalId = setInterval(updateTimer, 1000);
      if (promotion < date)
        router.push("/")
    }
    else
      router.push("/");
  }
}
</script>
<style lang="scss" scoped>
#timer2 {
  font-size: 35px;
  font-weight: 100;
  color: white;
  text-shadow: 0 0 20px #48C8FF;

  div {
    display: inline-block;
    min-width: 90px;

    span {
      color: #B1CDF1;
      display: block;
      font-size: .35em;
      font-weight: 400;
    }
  }
}

.badge {
  position: absolute;
  top: -25px;
  left: -10px;
  background-color: #6153cc;
  padding: 12px;
  border-radius: 10px 10px 10px 0;
}

.badge:after {
  position: absolute;
  top: 100%;
  left: 0;
  width: 0;
  height: 0;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #6153cc;
  content: '';
}

.katex-html {
  display: none;
}

.circle-div {
  background-color: #6153cc;
  height: 60px;
  width: 90vw;
  border-radius: 10px;
  position: fixed;
  bottom: 15px;
  right: 20px;
}

::placeholder {
  color: rgb(185, 185, 185);
  opacity: 1;
  /* Firefox */
}

::-ms-input-placeholder {
  /* Edge 12 -18 */
  color: rgb(185, 185, 185);
}

.login-box {
  top: 50%;
  left: 50%;
  position: fixed;
  width: 90vw;
  padding: 10px;
  transform: translate(-50%, -50%);
  z-index: 10000;
  background-color: rgb(24, 24, 24);
  box-sizing: border-box;
  box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
  border-radius: 10px;

}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWeb.woff2') format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWebBold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
}

span {
  font-family: IRANSansWeb;
  font-weight: bold;
}

@function gray($color) {
  @return rgb($color, $color, $color);
}

$red: rgb(239, 83, 80);
$orange: rgb(255, 160, 0);
$yellow: rgb(253, 216, 53);
$green: rgb(42, 252, 152);
$indigo: rgb(57, 73, 171);
$violet: rgb(103, 58, 183);

/* -- */

$blue: rgb(66, 165, 245);

@keyframes blink {

  from,
  25%,
  to {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(720deg);
  }

  to {
    transform: rotate(1440deg);
  }
}

@keyframes bounce {

  from,
  6.66%,
  17.66%,
  33.33% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  13.33%,
  14.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }

  23.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }

  26.66% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scaleY(0.95);
  }

  30% {
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
}

body {
  margin: 0px;
  overflow-x: hidden;
  padding: 0px;

  &::-webkit-scrollbar-track {
    background-color: gray(30);
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(white, 0.2);
    border-radius: 100px;
  }

  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  input,
  h1,
  h3,
  a,
  span {
    color: gray(90);
    font-family: IRANSansWeb;
    font-weight: bold;
    font-weight: 400;
    margin: 0px;
    padding: 0px;
  }
}

$backgroundImage: "https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2076&q=80";

.background-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.clear-button {
  backdrop-filter: blur(3px);
  background-color: rgba(white, 0.1);
  border: 1px solid rgba(white, 0.1);
  border-radius: 100px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;

  &:hover {
    background-color: rgba(white, 0.2);
    border: 1px solid rgba(white, 0.3);
  }
}

.text-button {
  backdrop-filter: blur(3px);
  background-color: rgba(white, 0.1);
  border-radius: 15px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;

  &:hover {
    background-color: rgba(white, 0.2);
    border: 1px solid rgba(white, 0.3);
  }
}

.text-button2 {
  background-color: rgba(white, 0.1);

}

#app {
  background-color: gray(30);

  &.logged-out {
    #app-info {
      margin-left: 40px;
      opacity: 1;
      transform: translateX(0%);
    }

    #app-background {
      cursor: pointer;
    }

    #sign-in-button-wrapper {
      opacity: 1;
      pointer-events: all;
      transform: translate(-50%, -40px);
    }
  }

  &.logging-in,
  &.verifying-log-in,
  &.log-in-error {
    #app-background {
      #app-background-image {
        filter: blur(8px);
        transform: scale(1.2);
      }
    }
  }

  &.logging-in,
  &.log-in-error {
    #app-pin-wrapper {
      opacity: 1;
      pointer-events: all;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  &.verifying-log-in {
    #app-loading-icon {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }

  &.log-in-error {
    #app-pin-wrapper {
      #app-pin {
        .app-pin-digit {
          background-color: rgba($red, 0.05);
          border-color: rgba($red, 0.5);
        }
      }
    }
  }

  &.logged-in {
    #app-menu {
      opacity: 1;
      pointer-events: all;
    }
  }

  .scrollable-component {
    cursor: grab;
    overflow: auto;
    user-select: none;
    width: 100%;

    &:active {
      cursor: grabbing;
    }

    &::-webkit-scrollbar {
      height: 0px;
      width: 0px;
    }
  }

  #app-loading-icon {
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, 0%);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    i {
      animation: 2s spin ease-in-out infinite;
      color: white;
      font-size: 2em;
    }
  }

  #app-background {
    height: 100%;
    left: 0px;
    overflow: hidden;
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 1;

    #app-background-image {
      height: 100%;
      transition: filter 250ms, transform 250ms;
      width: 100%;
    }
  }

  #app-info {
    bottom: 0px;
    left: 0px;
    margin: 40px;
    margin-left: 0px;
    opacity: 0;
    position: absolute;
    transform: translateX(-100%);
    transition: margin 250ms, opacity 250ms, transform 250ms;
    z-index: 2;
  }

  .user-status-button {
    cursor: pointer;
    margin-top: 10px;
    outline: none;
    padding: 10px;
    width: 100px;

    i {
      color: gray(245);
      font-size: 1.25em;
    }
  }

  #sign-in-button-wrapper {
    bottom: 0px;
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transform: translate(-50%, 40px);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    #sign-in-button {
      &:not(:hover) {
        animation: bounce 3s infinite;
        animation-delay: 3s;
      }
    }
  }

  .info {
    align-items: flex-end;
    display: flex;

    .time {
      color: gray(245);
      font-size: 6em;
      height: 80px;
      line-height: 80px;
      text-shadow: 2px 2px 2px rgba(black, 0.1);
    }

    .weather {
      display: inline-flex;
      height: 20px;
      margin-bottom: 6px;
      margin-left: 20px;

      i,
      span {
        align-items: center;
        display: inline-flex;
      }

      i {
        color: $yellow;
        font-size: 0.9em;
      }

      span {
        color: white;
      }

      .weather-type {
        height: 20px;
      }

      .weather-temperature-value {
        font-size: 1.5em;
        height: 20px;
        margin-left: 5px;
      }

      .weather-temperature-unit {
        align-items: flex-start;
        font-size: 0.8em;
        margin-left: 3px;
      }
    }
  }

  .reminder {
    display: flex;
    gap: 6px;
    margin-top: 10px;

    i,
    div {
      display: inline-flex;
    }

    i {
      color: gray(245);
      font-size: 0.8em;
      height: 12px;
      line-height: 12px;
    }

    span {
      color: rgba(white, 0.8);
      font-size: 1.1em;
    }

    .reminder-icon {
      align-items: center;
      height: 20px;
    }

    .reminder-time {
      align-items: flex-end;
      color: gray(30);
      font-size: 0.8em;
      height: 20px;
    }
  }

  #quick-nav {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    overflow: auto;
    padding-bottom: 5px;
    width: 100%;
    z-index: 3;

    .quick-nav-item {
      padding: 10px 20px;

      &:last-of-type {
        margin-right: 10px;
      }

      .quick-nav-item-label {
        color: gray(245);
        text-shadow: 0px 0px 2px rgba(black, 0.1);
      }
    }
  }

  #youtube-link {
    align-items: center;
    display: inline-flex;
    gap: 5px;
    margin-top: 10px;
    padding: 10px 20px;
    text-decoration: none;

    i,
    span {
      height: 20px;
      line-height: 20px;
    }

    i {
      color: $red;
    }

    span {
      color: white;
    }
  }

  .menu-section {
    margin-top: 20px;

    .menu-section-title {
      align-items: center;
      display: flex;
      gap: 6px;

      i,
      span {
        color: gray(245);
      }

      i {
        font-size: 1em;
      }

      .menu-section-title-text {
        color: rgba(white, 0.9);
        font-size: 1.4em;
        font-weight: bold;
      }
    }

    .menu-section-content {
      margin-top: 15px;
      padding-top: 5px;
    }
  }

  #restaurants-section {
    .menu-section-content {
      display: flex;
      gap: 1em;

      .restaurant-card {
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: 14vw;
        max-height: 240px;
        position: relative;
        transition: transform 250ms;
        width: 25%;

        &:hover {
          transform: translateY(-5px);

          .restaurant-card-content {
            .restaurant-card-content-items {
              margin-bottom: 30px;
            }
          }
        }

        .restaurant-card-content {
          background: linear-gradient(to top, rgba(black, 0.8), transparent);
          border-radius: 10px;
          height: 100%;
          width: 100%;

          .restaurant-card-content-items {
            bottom: 0px;
            display: flex;
            flex-direction: column;
            margin: 20px;
            position: absolute;
            right: 0px;
            text-align: right;
            transition: margin 250ms;

            .restaurant-card-title {
              color: gray(245);
              font-size: 1.5em;
            }

            .restaurant-card-desc {
              color: $blue;
              font-size: 0.9em;
            }
          }
        }
      }
    }
  }

  #weather-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      padding: 5px 0px;
      width: 100%;

      .day-card {
        backdrop-filter: blur(3px);
        background-color: rgba(white, 0.1);
        border: 1px solid rgba(white, 0.2);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        height: 8vw;
        max-height: 160px;
        min-height: 140px;
        min-width: 180px;
        position: relative;
        transition: transform 250ms;
        width: calc(100% / 7);

        &:last-of-type {
          margin-right: 5px;
        }

        .day-card-content {
          display: flex;
          flex-direction: column;
          height: calc(100% - 20px);
          justify-content: space-evenly;
          padding: 10px;

          i,
          span {
            color: gray(245);
            text-align: center;
          }

          .day-weather-temperature {
            align-items: flex-start;
            display: flex;
            font-size: 0.9em;
            justify-content: center;

            .day-weather-temperature-unit {
              font-size: 0.8em;
              margin-left: 3px;
            }
          }

          .day-weather-icon {
            font-size: 3.5em;
            text-shadow: 2px 2px 2px rgba(black, 0.1);

            &.sunny {
              color: $yellow;
            }

            &.rainy,
            &.stormy {
              color: $blue;
            }
          }

          .day-name {
            font-size: 0.9em;
            text-transform: uppercase;
          }
        }
      }
    }
  }

  #tools-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      width: 100%;
      height: 60vh;

      .tool-card {
        background-color: gray(30);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: vw;
        max-height: 220px;
        min-height: 180px;
        min-width: 220px;

        position: relative;
        transition: transform 250ms;
        width: calc(100% / 6);

        &:hover {
          transform: translateY(-5px);

          .tool-card-background {
            filter: grayscale(0);
          }
        }

        .tool-card-background {
          border-radius: 10px;
          height: 100%;
          left: 0px;
          position: absolute;
          top: 0px;
          transition: filter 250ms;
          width: 100%;
        }

        .tool-card-content {
          display: flex;

          i,
          span {
            color: gray(245);
            position: absolute;
            width: 100%;
            height: 60%;

          }

          .tool-card-content-header {
            display: flex;
            flex-direction: column;
            gap: 2px;



          }

          .tool-card-icon {
            color: gray(245);
            font-size: 2em;
          }
        }
      }
    }
  }

  #movies-section {
    .menu-section-content {
      display: flex;
      gap: 1em;

      #movie-card-1 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($indigo, 0.4), transparent, rgba(black, 0.4));
        }
      }

      #movie-card-2 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($violet, 0.4), transparent, rgba(black, 0.4));
        }
      }

      #movie-card-3 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($red, 0.4), transparent, rgba(black, 0.4));
        }
      }

      #movie-card-4 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($green, 0.4), rgba(black, 0.1), rgba(black, 0.4));
        }
      }

      .movie-card {
        background-color: gray(30);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: 40vw;
        max-height: 600px;
        min-height: 460px;
        min-width: 260px;
        overflow: hidden;
        position: relative;
        transition: transform 250ms;
        width: calc(100% / 4);

        &:hover {
          transform: translateY(-5px);

          .movie-card-background {
            transform: scale(1.05);
          }

          .movie-card-content {
            i {
              transform: translate(-20%, -20%) scale(1.2);
            }
          }
        }

        .movie-card-background {
          border-radius: 10px;
          height: 100%;
          left: 0px;
          position: absolute;
          top: 0px;
          transition: transform 250ms;
          width: 100%;
          z-index: 1;
        }

        .movie-card-content {
          background: linear-gradient(to top, rgba(black, 0.5), rgba(black, 0.1), rgba(black, 0.4));
          border-radius: 10px;
          height: 100%;
          position: relative;
          z-index: 2;

          .movie-card-info {
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 30px;

            span {
              text-shadow: 2px 2px 2px rgba(black, 0.1);
            }

            .movie-card-title {
              color: gray(245);
              font-size: 1.5em;
              font-weight: bold;
            }

            .movie-card-desc {
              color: gray(200);
              font-size: 0.9em;
            }
          }

          i {
            bottom: 0px;
            color: gray(245);
            font-size: 5em;
            padding: 30px;
            position: absolute;
            right: 0px;
            text-shadow: 2px 2px 2px rgba(black, 0.1);
            transition: transform 250ms;
          }
        }
      }
    }
  }

  #app-pin-wrapper {
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -30%) scale(0.8);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    #app-pin-label {
      color: gray(245);
      font-size: 0.9em;
      margin: 10px;
      text-shadow: 2px 2px 2px rgba(black, 0.1);

      #app-pin-cancel-text {
        cursor: pointer;
        margin-left: 2px;

        &:hover {
          text-decoration: underline;
        }
      }

      #app-pin-error-text {
        color: $red;
      }
    }

    #app-pin-hidden-input {
      background-color: transparent;
      border: none;
      height: 0px;
      outline: none;
      pointer-events: none;
      position: absolute;
      width: 0px;
    }

    #app-pin {
      display: flex;
      gap: 10px;

      .app-pin-digit {
        align-items: center;
        background-color: rgba(white, 0.05);
        border: 1px solid rgba(white, 0.2);
        border-radius: 10px;
        box-shadow: 2px 2px 2px rgba(black, 0.06);
        display: inline-flex;
        font-size: 3em;
        height: 80px;
        justify-content: center;
        position: relative;
        transition: background-color 250ms, border-color 250ms;
        width: 60px;

        &:after,
        &:before {
          box-shadow: 2px 2px 2px rgba(black, 0.06);
          content: "";
          position: absolute;
          transition: opacity 250ms, transform 250ms;
          z-index: 2;
        }

        &:before {
          background-color: gray(245);
          border-radius: 10px;
          bottom: 0px;
          height: 3px;
          left: 15%;
          opacity: 0;
          transform: translateY(0px);
          width: 70%;
        }

        &:after {
          background-color: gray(245);
          border-radius: 20px;
          height: 20px;
          opacity: 0;
          transform: scale(0.25);
          width: 20px;
        }

        &.focused {
          &:before {
            animation: blink 2s ease-in-out infinite;
            opacity: 1;
            transform: translateY(-10px);
          }
        }

        &.hidden {
          &:after {
            opacity: 1;
            transform: scale(1);
          }

          .app-pin-digit-value {
            opacity: 0;
            transform: scale(0.25);
          }
        }

        .app-pin-digit-value {
          color: gray(245);
          transition: opacity 250ms, transform 250ms;
        }
      }
    }
  }

  @media(min-width: 768px) {
    #app-menu {
      overflow: hidden;
      opacity: 0;
      pointer-events: none;
      position: relative;
      transition: opacity 250ms, transform 250ms;
      z-index: 2;

      #app-menu-content-wrapper {
        background: #212529;
        min-height: 80vh;
        padding: 80px;
        padding-top: 0px;

        #app-menu-content {
          margin: auto;
          max-width: 30vw;
          position: relative;

          #app-menu-content-header {
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
  }

  @media(max-width: 767px) {
    #app-menu {
      overflow: hidden;
      opacity: 0;
      pointer-events: none;
      position: relative;
      transition: opacity 250ms, transform 250ms;
      z-index: 2;

      #app-menu-content-wrapper {
        background: #212529;
        min-height: 80vh;
        padding: 80px;
        padding-top: 0px;

        #app-menu-content {
          margin: auto;
          max-width: 1600px;
          position: relative;

          #app-menu-content-header {
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
  }
}

@media(max-width: 1300px) {
  #app {
    &.logged-out {
      #sign-in-button-wrapper {
        transform: translate(-40px, 0px);
      }
    }

    #sign-in-button-wrapper {
      bottom: 40px;
      left: auto;
      right: 0px;
      transform: translate(40px, 0px);
    }

    #app-menu {
      #app-menu-content-wrapper {
        padding: 20px;

        #app-menu-content {
          #restaurants-section {
            .menu-section-content {
              flex-wrap: wrap;

              .restaurant-card {
                height: 22vh;
                max-height: 300px;
                position: relative;
                width: calc(50% - 0.5em);
              }
            }
          }

          #tools-section {
            .menu-section-content {

              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}



@media(max-width: 600px) {
  #app {
    .info {
      .time {
        font-size: 4em;
        height: 60px;
        line-height: 60px;
      }
    }

    .user-status-button {
      width: 60px;
    }

    #app-menu {
      #app-menu-content-wrapper {
        #app-menu-content {
          #restaurants-section {
            .menu-section-content {
              flex-direction: column;

              .restaurant-card {
                height: 40vw;
                position: relative;
                width: 100%;
              }
            }
          }

          #tools-section {
            .menu-section-content {

              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

@media(max-width: 400px) {
  #app {
    #app-menu {
      #app-menu-content-wrapper {
        #app-menu-content {
          #tools-section {
            .menu-section-content {

              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

.overflow2 {
  margin: 0 0 0 0;
  text-overflow: ellipsis;
  width: 82vw;
  /**
   * Required properties to achieve text-overflow
   */
  white-space: nowrap;
  overflow: hidden;
}

.overflow {
  margin: 0 0 2em 0;
  text-overflow: ellipsis;
  /**
   * Required properties to achieve text-overflow
   */
  white-space: nowrap;
  overflow: hidden;
}
</style>